export function createCookie(
  name: string,
  value: string,
  options: { expires?: Date; includeSubdomains?: boolean } = {}
) {
  // no expiration date set means we will treat this as a session cookie
  const expiresAt = options.expires != null ? '; expires=' + options.expires.toUTCString() : '';
  // including domain ensures that this cookie is also shared across subdomains
  const domain = options.includeSubdomains ? '; domain=' + window.location.hostname : '';

  document.cookie = name + '=' + value + expiresAt + domain + '; path=/';
}

export function eraseCookie(name: string) {
  // Erases cookies created with createCookie by setting expiry to the past
  // Since the cookie will only be deleted if we match the same 'domain' setting, we try delete for both includeSubdomains settings
  // to avoid the caller having to remember the setting that was used when it was created
  const pastDate = new Date(0);
  createCookie(name, '', { expires: pastDate, includeSubdomains: true });
  createCookie(name, '', { expires: pastDate, includeSubdomains: false });
}

export function stringifyCookie(cookieData: unknown) {
  return btoa(JSON.stringify(cookieData));
}

export function parseCookie(cookieValue: string | null) {
  if (cookieValue == null || cookieValue.length === 0) {
    return null;
  }
  let json;
  try {
    json = atob(cookieValue);
  } catch (error) {
    // old cookies were not Base64 encoded
    return null;
  }
  try {
    return JSON.parse(json);
  } catch (error) {
    // Invalid JSON in cookie
    return null;
  }
}

export function readCookie(name: string) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }

  return null;
}
